import React from 'react';
import './Blog.css';
import { Link } from 'react-router-dom';

const Blog = () => {
    return (
        <section className="blog" id="blog">
            <div className="container">
                <div className="blog-section-header">
                    <div>
                        <div className="eyebrow rv in">Blog</div>
                        <h2 className="s-title rv in d1" style={{ marginBottom: 0 }}>
                            Ideas que<br />informan
                        </h2>
                    </div>
                    <Link to="/blog" className="blog-all rv in d2">
                        Ver todos los artículos
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M2 7h10M7 2l5 5-5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </Link>
                </div>

                <div className="blog-grid">
                    {/* Tarjeta Principal (Destacada) */}
                    <Link to="/blogs/que-es-agente-ia" className="blog-card rv in">
                        <div className="blog-img">
                            <img src="/imagenes_blogs/miniatura_blog1.png" alt="Miniatura Agente IA" />
                        </div>
                        <div className="blog-body">
                            <div className="blog-cat">Logística & IA</div>
                            <div className="blogs-title">
                                ¿Qué es un Agente de IA y por qué necesitas uno?
                            </div>
                            <div className="blogs-meta">
                                <span>5 min de lectura</span>
                                <div className="blog-meta-dot"></div>
                                <span>Diciembre 2025</span>
                            </div>
                        </div>
                    </Link>

                    {/* Tarjeta Secundaria 1 */}
                    <Link to="/blogs/AliadoInvisible" className="blog-card rv in d1">
                        <div className="blog-img">
                            <img src="/imagenes_blogs/miniatura_blog6.png" alt="Miniatura Simbiosis IA" />
                        </div>
                        <div className="blog-body">
                            <div className="blog-cat">IA Aplicada</div>
                            <div className="blogs-title">
                                El Aliado Invisible: La Simbiosis Humano-IA
                            </div>
                            <div className="blogs-meta">
                                <span>6 min</span>
                                <div className="blog-meta-dot"></div>
                                <span>Marzo 2026</span>
                            </div>
                        </div>
                    </Link>

                    {/* Tarjeta Secundaria 2 */}
                    <Link to="/blogs/despliegue-rapido-n8n" className="blog-card rv in d2">
                        <div className="blog-img">
                            <img src="/imagenes_blogs/miniatura_blog2.png" alt="Miniatura n8n" />
                        </div>
                        <div className="blog-body">
                            <div className="blog-cat">Industria 4.0</div>
                            <div className="blogs-title">
                                Cómo n8n revoluciona la automatización con IA
                            </div>
                            <div className="blogs-meta">
                                <span>4 min</span>
                                <div className="blog-meta-dot"></div>
                                <span>Diciembre 2025</span>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default Blog;